export default __webpack_public_path__ + "locales/si/MainBar.json?hash=ae957bbafc4157bdeb667c4e69b285dc";